<template>
  <BaseButton
    :class="color"
    :width="width"
    :height="height"
    :fontSize="fontSize"
    :fontFamily="fontFamily"
    :borderRadius="borderRadius"
  >
    <template #title>
      <slot name="title"></slot>
    </template>
  </BaseButton>
</template>

<script>
import BaseButton from './BaseButton.vue';

export default {
  components: {
    BaseButton,
  },

  props: {
    color: {
      type: String,
      default: 'border',
    },
    width: {
      type: Number,
    },
    height: {
      type: Number,
    },
    fontSize: {
      type: Number,
    },
    fontFamily: {
      type: String,
    },
    borderRadius: {
      type: Number,
      default: 3,
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  color: #ffffff;
  border: 0;

  &.border {
    border: 1px solid #d2d2d2;
    color: #575757;

    &:hover {
      background-color: #eaeaea;
    }
  }

  &.purple {
    background: #5917b8;

    &:hover {
      background-color: #350e6d;
    }
  }

  &.purpleBorder {
    background: #ffffff;
    border: 1px solid #5917b8;
    color: #5917b8;

    &:hover {
      background-color: #5917b8;
      color: #ffffff;
    }
  }

  &.black {
    background: #0a0a0a;
  }

  &.red {
    background: #d7142b;

    &:hover {
      background-color: #a81021;
    }
  }

  &.redBorder {
    background: #ffffff;
    border: 1px solid #d7142b;
    color: #d7142b;

    &:hover {
      background-color: #d7142b;
      color: #ffffff;
    }
  }

  &.blue {
    background: #0070bd;
  }

  &.dkBlue {
    background: #1c236c;

    &:hover {
      background-color: #273198;
    }
  }

  &.lightBlue {
    background: #b5d0ea;
  }

  &.gray77 {
    background: #777777;

    &:hover {
      background-color: #222222;
    }
  }

  &.grayEA {
    background: #eaeaea;
    color: #222222;

    &:hover {
      background-color: #e0e0e0;
    }
  }

  &.grayF8 {
    background: #f8f8f8;
    color: #575757;
    border: 1px solid #e0e0e0;
  }
}
</style>
